import React from 'react';
import { HardHat, Package, FileText, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <HardHat className="w-5 h-5 text-amber-400" data-id="element-282" />,
    text: '+2.000 herreros'
  }, {
    icon: <Package className="w-5 h-5 text-amber-400" data-id="element-283" />,
    text: '6 Módulos completos'
  }, {
    icon: <FileText className="w-5 h-5 text-amber-400" data-id="element-284" />,
    text: '225+ páginas de planos'
  }, {
    icon: <Star className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-285" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-zinc-900 border-y border-amber-900/40 py-6" data-id="element-286">
      <div className="container mx-auto px-4" data-id="element-287">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-288">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-zinc-100" data-id="element-289">
              {stat.icon}
              <span data-id="element-290">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}